import client from './client';

export const tripsApi = {
  getDashboard: async () => {
    const res = await client.get('/trips/dashboard');
    return res.data?.data || res.data;
  },

  saveDraft: async (payload) => {
    const res = await client.post('/trips/draft', payload);
    return res.data?.data || res.data;
  },

  updateDraft: async (id, payload) => {
    const res = await client.put(`/trips/draft/${id}`, payload);
    return res.data?.data || res.data;
  },

  getDraft: async (id) => {
    const res = await client.get(`/trips/draft/${id}`);
    return res.data?.data || res.data;
  },

  deleteDraft: async (id) => {
    const res = await client.delete(`/trips/draft/${id}`);
    return res.data;
  },

  publishTrip: async (payload, fromDraftId) => {
    const url = fromDraftId ? `/trips/publish?fromDraftId=${fromDraftId}` : '/trips/publish';
    const res = await client.post(url, payload);
    return res.data?.data || res.data;
  },

  getSharedTrip: async (id) => {
    const res = await client.get(`/trips/shared/${id}`);
    return res.data?.data || res.data;
  },

  updateSharedTrip: async (id, payload) => {
    const res = await client.put(`/trips/shared/${id}`, payload);
    return res.data?.data || res.data;
  },

  deleteSharedTrip: async (id) => {
    const res = await client.delete(`/trips/shared/${id}`);
    return res.data;
  },

  joinSharedTrip: async (inviteCode) => {
    const res = await client.post(`/trips/shared/join/${inviteCode}`);
    return res.data;
  },

  uploadImage: async (imageData) => {
    const res = await client.post('/trips/upload-image', { imageData });
    return res.data;
  },

  acceptTrip: async (id) => {
    const res = await client.post(`/trips/shared/${id}/accept`);
    return res.data;
  },

  createChangeRequest: async (id, payload) => {
    const res = await client.post(`/trips/shared/${id}/change-requests`, payload);
    return res.data;
  },

  getChangeRequests: async (id) => {
    const res = await client.get(`/trips/shared/${id}/change-requests`);
    return res.data?.data || res.data;
  },

  manualMergeChangeRequests: async (id, payload) => {
    const res = await client.post(`/trips/shared/${id}/merge`, payload);
    return res.data;
  },

  applyAiMergedPlan: async (id, payload) => {
    const res = await client.post(`/trips/shared/${id}/ai-merge-apply`, payload);
    return res.data;
  },

  triggerAiMerge: async (payload) => {
    const aiBaseUrl = process.env.REACT_APP_AI_PLANNER_URL || 'http://localhost:4000';
    const res = await client.post(`${aiBaseUrl}/api/v1/plans/ai-merge`, payload, {
      timeout: 120000,
    });
    return res.data?.data || res.data;
  },

  rejectChangeRequest: async (tripId, requestId, reason) => {
    const res = await client.patch(`/trips/shared/${tripId}/change-requests/${requestId}/reject`, { reason });
    return res.data;
  },

  mergeSingleChangeRequest: async (tripId, requestId) => {
    const res = await client.post(`/trips/shared/${tripId}/change-requests/${requestId}/merge`);
    return res.data;
  },

  // ─── Post-Trip Feedback & Reviews API ──────────────────────────────────────
  submitTripFeedback: async (tripId, payload) => {
    const res = await client.post(`/trips/shared/${tripId}/feedback`, payload);
    return res.data;
  },

  getTripFeedbacks: async (tripId) => {
    const res = await client.get(`/trips/shared/${tripId}/feedback`);
    return res.data?.data || res.data;
  },

  getMyFeedbacks: async () => {
    const res = await client.get('/trips/feedback/my-feedbacks');
    return res.data?.data || res.data;
  },

  // ─── Real-Time Notifications API ──────────────────────────────────────────
  getNotifications: async () => {
    const res = await client.get('/notifications');
    return res.data?.data || res.data;
  },

  markNotificationAsRead: async (id) => {
    const res = await client.patch(`/notifications/${id}/read`);
    return res.data?.data || res.data;
  },

  markAllNotificationsAsRead: async () => {
    const res = await client.patch('/notifications/read-all');
    return res.data?.data || res.data;
  },

  deleteNotification: async (id) => {
    const res = await client.delete(`/notifications/${id}`);
    return res.data?.data || res.data;
  },

  clearAllNotifications: async () => {
    const res = await client.delete('/notifications');
    return res.data?.data || res.data;
  },
};

export default tripsApi;
